import moment from "moment";

class ValueObject {
  constructor(vo) {
    if (vo) {
      this.__created = moment();
      /* Copy the properties of the value object from the server. */
      Object.assign(this, vo);

      this.__lastUpdate = moment(this.lastUpdate);
    }
  }
}

export class TemplateBlock extends ValueObject {
  /* vo is the template block value object that is returned from the server. */
  constructor(vo) {
    super(vo);

    /* The article as is returned by the server. */
    this.articles = [];
    this.level = Math.max(parseInt(this.level),1);
  }

  removeArticleAllowed() {
    return this.expiresOn >= Date.now();
  }
}

export class ScenarioTemplatePlan extends ValueObject {
  constructor(vo) {
    super(vo);

    this._from = moment(this.from);
    /* If the to date is not defined, then set it to a moment very far from now. */
    this._to = this.to ? moment(this.to) : moment().add(10, 'years');
  }
}

export class ArticleListItem extends ValueObject {
  constructor(vo) {
    super(vo);

    /* Get the validity (time frame). */
    if (this.validity) {
      this.__validity = {
        from: moment(this.validity.from),
        to: moment(this.validity.to)
      }
    } else {
      this.__validity = {
        from: moment(),
        to: moment().add(10, 'years')
      }
    }
  }
}

export class Article extends ArticleListItem {
  constructor(vo) {
    super(vo);

    if (!this.minimalDuration) {
      this.minimalDuration = 5; // seconds
    }
    this.minimalDuration = Math.max(0,this.minimalDuration);
    this.level = Math.max(1,parseInt(this.level));

    /* Fetch the content based on contentType. */
    try {
      this.__content = this.content[this.contentType];
    } catch (err) {
      console.debug('Artikel heeft geen content');
      this.__content = 'Artikel heeft geen content';
    }
  }
}

export class SystemError {
  constructor(title, description, level) {
    this.title = title;
    this.description = description;
    this.level = level;
    this.timestamp = new Date();
  }
}



// WEBPACK FOOTER //
// ./client/app/model/model.js